<template>
  <div id="newModuleIPCOMTact">
    <v-stepper v-model="step" vertical>
      <v-stepper-step :complete="step > 1" step="1" color="#27e96a">
        Agregar Módulo
        <small>Configure un módulo de llamadas</small>
      </v-stepper-step>

      <v-form ref="form">
        <v-stepper-content step="1">
          <span class="text-body-2 font-weight-bold my-2 pl-2">Modo</span>
          <div class="pl-2">
            <v-btn-toggle
              color="indigo darken-4"
              v-model="dataModule.mode"
              mandatory
            >
              <v-btn value="api" class="button-tertiary">
                <span>API</span>
              </v-btn>
              <v-btn v-if="false" value="massive">
                <span>Rsync</span>
              </v-btn>
            </v-btn-toggle>
          </div>
          <div v-if="dataModule.mode" class="d-flex flex-wrap">
            <div class="d-flex flex-column flex-grow-1 flex-shrink-0 px-2">
              <span class="text-body-2 font-weight-bold my-2"
                >Nombre de módulo</span
              >
              <v-text-field
                class="customInpunt"
                placeholder="Nombre"
                v-model="dataModule.name"
                :rules="requiredRules"
                single-line
                solo
              ></v-text-field>
            </div>
            <div class="d-flex flex-column flex-grow-1 flex-shrink-0 px-2">
              <span class="text-body-2 font-weight-bold my-2"
                >Ip del módulo</span
              >
              <v-text-field
                class="customInpunt"
                placeholder="00.00.00.00"
                v-model="dataModule.ip"
                :rules="requiredRules"
                single-line
                solo
              ></v-text-field>
            </div>
          </div>
          <div v-if="dataModule.mode" class="d-flex flex-wrap">
            <div class="d-flex flex-column flex-grow-1 flex-shrink-0 px-2">
              <span class="text-body-2 font-weight-bold my-2">Token</span>
              <v-text-field
                class="customInpunt"
                placeholder="Token"
                v-model="dataModule.token"
                :rules="requiredRules"
                single-line
                solo
              ></v-text-field>
            </div>
            <div class="d-flex flex-column flex-grow-1 flex-shrink-0 px-2">
              <span class="text-body-2 font-weight-bold my-2"
                >ID de servidor</span
              >
              <v-text-field
                class="customInpunt"
                placeholder="ID de servidor"
                v-model="dataModule.serverId"
                :rules="requiredRules"
                single-line
                solo
                maxlength="10"
              ></v-text-field>
            </div>
            <div
              v-if="dataModule.mode == 'massive'"
              class="d-flex flex-column flex-grow-1 flex-shrink-0 px-2"
            >
              <span class="text-body-2 font-weight-bold my-2">Llave SSH</span>
              <v-textarea
                class="customInpunt"
                placeholder="Llave"
                v-model="dataModule.sshCertificate"
                :rules="[
                  (v) => !!v || dataModule.mode == 'api' || 'Campo requerido',
                ]"
                solo
              ></v-textarea>
            </div>
          </div>
          <div v-if="dataModule.mode" class="d-flex">
            <v-btn
              @click="$emit('listState', true)"
              outlined
              class="ma-2 button-primary"
              >Cancelar</v-btn
            >
            <v-btn class="ma-2 button-tertiary" @click="nextStep()">
              <span class="white--text">Guardar</span>
            </v-btn>
          </div>
        </v-stepper-content>
      </v-form>

      <v-stepper-step :complete="step > 2" step="2" color="#27e96a">
        Editar etiquetas
        <small>Personalice las etiquetas</small>
      </v-stepper-step>
      <v-form ref="form2">
        <v-stepper-content step="2">
          <div class="d-flex flex-wrap">
            <div class="d-flex flex-column flex-grow-1 flex-shrink-0 px-2">
              <span class="text-body-2 font-weight-bold my-2"
                >Etiqueta predeterminada</span
              >
              <v-select
                v-for="(item, index) in dataList"
                :key="index"
                class="customInpunt"
                placeholder="Seleccionar"
                v-model="item.list"
                :items="list"
                :item-text="items"
                :rules="requiredRules"
                solo
              ></v-select>
            </div>
            <div class="d-flex flex-column flex-grow-1 flex-shrink-0 px-2">
              <span class="text-body-2 font-weight-bold my-2"
                >Etiqueta de grabación</span
              >
              <div
                class="d-flex"
                v-for="(item, index) in dataList"
                :key="index"
              >
                <v-text-field
                  class="customInpunt"
                  placeholder="Etiqueta"
                  v-model="item.newTag"
                  :rules="requiredRules"
                  single-line
                  solo
                ></v-text-field>
                <v-btn icon v-if="index > 0" @click="delValue(index)">
                  <v-icon color="#2e2e2d">mdi-close-circle-outline</v-icon>
                </v-btn>
                <v-btn
                  icon
                  v-if="
                    dataList.length == index + 1 && item.list && item.newTag
                  "
                  @click="addValue()"
                >
                  <v-icon color="#27e96a">mdi-plus-circle-outline</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
          <div v-if="dataList[0].list && dataList[0].newTag" class="d-flex">
            <v-btn @click="step = 1" outlined c class="ma-2 button-primary"
              >Cancelar</v-btn
            >
            <v-btn
              class="ma-2 button-tertiary"
              @click="moduleEdit ? editData() : saveData()"
            >
              <span class="white--text">Guardar</span>
            </v-btn>
          </div>
        </v-stepper-content>
      </v-form>
    </v-stepper>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="showError" color="red" :timeout="5000" max-width="100">
      {{ textError }}
    </v-snackbar>
  </div>
</template>
<script>
import { httpByCurrentCustomer } from "../../lib/client";
export default {
  props: ["moduleEdit"],
  data() {
    return {
      step: 1,
      dataList: [
        {
          list: "",
          newTag: "",
        },
      ],
      dataModule: {
        name: "",
        enabled: true,
        ip: "",
        token: "",
        serverId: "",
        mode: "api",
        sshCertificate: "",
        tagMapping: {
          OPT1: "",
          OPT2: "",
          OPT3: "",
          OPT4: "",
          OPT5: "",
          OPT6: "",
          OPT7: "",
          OPT8: "",
          OPT9: "",
          OPT10: "",
          OPT11: "",
          OPT12: "",
          "COD ACT1": "",
          "COD ACT2": "",
        },
      },
      list: [
        "OPT1",
        "OPT2",
        "OPT3",
        "OPT4",
        "OPT5",
        "OPT6",
        "OPT7",
        "OPT8",
        "OPT9",
        "OPT10",
        "OPT11",
        "OPT12",
        "COD ACT1",
        "COD ACT2",
      ],
      requiredRules: [(v) => !!v || "Campo requerido"],
      showError: false,
      textError: "",
      loading: false,
    };
  },
  mounted() {
    if (this.moduleEdit) {
      this.dataModule = this.moduleEdit;
      this.step = 2;
      this.dataList = Object.entries(this.dataModule.tagMapping)
        .filter(([key, val]) => key && val)
        .map(([key, val]) => ({
          list: key,
          newTag: val,
        }));
      if (this.dataList.length < 1) {
        this.dataList = [
          {
            list: "",
            newTag: "",
          },
        ];
      }
    }
  },
  methods: {
    addValue() {
      const item = {
        list: "",
        newTag: "",
      };
      this.dataList.push(item);
    },
    delValue(key) {
      this.dataList.splice(key, 1);
    },
    nextStep() {
      if (this.$refs.form.validate()) {
        this.step = 2;
      }
    },
    saveData() {
      if (this.$refs.form2.validate()) {
        this.loading = true;
        const json = this.transformDataSend();
        httpByCurrentCustomer()
          .post("ipcomtactModules", { json })
          .then(() => {
            this.loading = false;
            this.$emit("listState", true);
          })
          .catch(() => {
            this.loading = false;
            this.textError =
              "Ha ocurrido un error, por favor intento de nuevo.";
            this.showError = true;
          });
      }
    },
    editData() {
      if (this.$refs.form2.validate()) {
        this.loading = true;
        const json = this.transformDataSend();
        httpByCurrentCustomer()
          .put("ipcomtactModules", { json })
          .then(() => {
            this.loading = false;
            this.$emit("listState", true);
          })
          .catch(() => {
            this.loading = false;
            this.textError =
              "Ha ocurrido un error, por favor intento de nuevo.";
            this.showError = true;
          });
      }
    },
    transformDataSend() {
      for (const k of Object.keys(this.dataModule.tagMapping)) {
        this.dataList.map((item) => {
          if (k == item.list) {
            this.dataModule.tagMapping[k] = item.newTag;
          }
        });
      }
      return this.dataModule;
    },
  },
};
</script>
<style lang="scss">
#newModuleIPCOMTact {
  animation: fade 1s ease-in-out;
  .v-input {
    &.customInpunt {
      max-width: 500px;
      .v-input__control {
        min-height: 35px;
        .v-input__slot {
          box-shadow: none;
          border: 1px solid rgba(0, 0, 0, 0.12);
        }
      }
    }
  }
}
</style>
